// extracted by mini-css-extract-plugin
export var arrow = "bm_d1";
export var check = "bm_d2";
export var details = "bm_dW";
export var icon = "bm_n";
export var info = "bm_dX";
export var list = "bm_dY";
export var more = "bm_d0";
export var remove = "bm_d3";
export var ribbon = "bm_dZ";
export var row = "bm_dV";